// libs
import { useCallback, useContext, useRef } from "react";

// stores
import { AppContext } from "@store/context/App";

// constants
import { ERROR_MESSAGE, ErrorEnum } from "../../constants/Error";

// types
import { IAlert } from "../../defs/Alert";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function useAlertMessageHandler() {
    const timerRef = useRef(null);

    const { showAlertMessage, hideAlertMessage } = useContext(AppContext);

    const showErrorAlertMessage = useCallback((errors, customErrorMessage?: IAlert): void => {
        /**
         * if ErrorType exist and equal to ErrorEnum in that case we will show the Enum specific
         * error message otherwise we will show generic Server Error message.
         */
        const errorMessage: IAlert =
            errors.length && errors[0].errorType && ERROR_MESSAGE[errors[0].errorType]
                ? ERROR_MESSAGE[errors[0].errorType]
                : ERROR_MESSAGE[ErrorEnum.SERVER_ERROR];
        const errorAlertMessage = { ...(customErrorMessage ?? errorMessage), enableRefreshCTA: false };
        showAlertMessage({ alertMessage: errorAlertMessage });

        // set the timer to hide the alert after autoTimeout seconds
        if (errorAlertMessage.autoTimeout && errorAlertMessage.autoTimeout > 0) {
            timerRef.current = setTimeout(() => {
                hideErrorAlertMessage();
                timerRef.current = null; // reset the ref
            }, errorAlertMessage.autoTimeout);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const hideErrorAlertMessage = useCallback((): void => {
        hideAlertMessage();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const showSuccessAlertMessage = useCallback((alertMessage: IAlert): void => {
        showAlertMessage({ alertMessage: { ...alertMessage, enableRefreshCTA: false } });

        // set the timer to hide the alert after passed autoTimeout seconds
        timerRef.current = setTimeout(() => {
            hideErrorAlertMessage();
            timerRef.current = null; // reset the ref
        }, alertMessage.autoTimeout);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const hideSuccessAlertMessage = useCallback((): void => {
        hideAlertMessage();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { showErrorAlertMessage, hideErrorAlertMessage, showSuccessAlertMessage, hideSuccessAlertMessage };
}

export default useAlertMessageHandler;
